import { useContext } from "react";
import { RootContext } from "../rootContext";
export var useRootController = function () {
    return useContext(RootContext);
};
export var useControllers = function () {
    return useContext(RootContext).$children;
};
